export default "__VITE_ASSET__d6d8f214__"